import { Colors } from '@sigma-frontend-libs/commons'

import { components, inputModes, services } from '@/utils'

import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'

function renderSalonIdField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.salonId,
        label: this.getTranslate(`${services.yclients}.labels.salon`),
        mode: inputModes['line-label'],
        dense: true,
        rounded: true,
        required: true,
        autofocus: true,
        details: false,
        mask: /^\d{1,9}$/
      },
      on: {
        input: event => {
          this.proxy.salonId = event
        }
      }
    }
  )
}

function renderIsActiveField(h) {
  if (!this.isNew) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.isActive,
          outline: true,
          tooltip: this.getTranslate(`${services.yclients}.labels.isActive`)
        },
        on: {
          input: event => {
            this.proxy.isActive = event
          }
        }
      }
    )
  }
}

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

function renderSalon(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { 'grid-template-columns': [ '1fr', this.isNew ? undefined : 'auto' ].filter(Boolean).join(' ') }
    },
    [
      renderSalonIdField.call(this, h),
      renderIsActiveField.call(this, h)
    ]
  )
}

function renderError(h) {
  if (this.proxy.error) {
    return h(
      info,
      {
        props: {
          value: this.proxy.error,
          color: Colors.error
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: 'grid grid-gap--12'
    },
    [
      renderSalon.call(this, h),
      renderSelectorOwner.call(this, h),
      renderError.call(this, h)
    ]
  )
}
